module.exports = __webpack_public_path__ + "img/Larry Stuts.bc0ba18a.jpg";